import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import CtnLang from './CtnLang';

import ValidityAdornment from './ValidityAdornment';
import { useMassActionState } from 'src/components/massAction/MassActionStateContext';

const SmsContentLabel = () => {
  const { t } = useTranslation();
  const [{ contentValidity }] = useMassActionState();
  return (
    <div style={{ display: 'flex' }}>
      <Typography
        color={contentValidity.contentIsEmpty ? 'error' : 'textSecondary'}
        style={{
          margin: '5px 10px',
        }}
        variant="subtitle2"
        noWrap
      >
        {t('smartmessaging.contentEditor.sms.content')}
      </Typography>
      <ValidityAdornment
        valid={contentValidity.isValid}
        message={
          <ul>
            {contentValidity.invalidities.map(msg => (
              <li key={msg}>{msg}</li>
            ))}
          </ul>
        }
      />
      <div style={{ marginRight: 0, marginLeft: 'auto' }}>
        <CtnLang />
      </div>
    </div>
  );
};

SmsContentLabel.propTypes = {
  contentValidity: PropTypes.object.isRequired,
};

export default SmsContentLabel;
